import { useState } from 'react';
import { logError } from '../components/logger';
import { useRegisterFamilyMemberToClinicMutation, useRegisterUserToClinicMutation } from '../graphql/types-and-hooks';

export const useAppointmentBooking = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [patientId, setPatientId] = useState('');

  const [registerUserToClinicMutation] = useRegisterUserToClinicMutation();
  const [registerFamilyMemberToClinicMutation] = useRegisterFamilyMemberToClinicMutation();

  const registerPatient = async (doctor: any, patient: any, USER_FK: string, CLINIC_GROUP_CRM: string, LOCATION_ID: string) => {
    setIsLoading(true);
    try {
      if (patient?.family_member_key) {
        const result = await registerFamilyMemberToClinicMutation({
          variables: {
            input: {
              clinic_group_crm: doctor.clinic_group_crm || CLINIC_GROUP_CRM,
              user_fk: doctor.user_fk || USER_FK,
              location_id: doctor.location_id || LOCATION_ID,
              family_member_key: parseInt(patient?.family_member_key),
            },
          },
        });
        return result?.data?.registerFamilyMemberToClinic?.patient_id;
      } else {
        const result = await registerUserToClinicMutation({
          variables: {
            input: {
              clinic_group_crm: doctor.clinic_group_crm || CLINIC_GROUP_CRM,
              user_fk: doctor.user_fk || USER_FK,
              location_id: doctor.location_id || LOCATION_ID,
            },
          },
        });
        const newPatientId = result?.data?.registerUserToClinic?.patient_id;
        setPatientId(newPatientId);
        return newPatientId;
      }
    } catch (error) {
      logError('bookAppointmentRegisterError', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    patientId,
    registerPatient,
    setIsLoading
  };
};